import React from 'react';
import { Play } from 'lucide-react';
import GameArtwork from '../../components/GameArtwork';
import { HOOKS, hook } from '../../lib/domHooks';

/**
 * Paris şemasının oyun kartı.
 *
 * Referans arayüzde kart **yalnızca görselden** oluşur: oyun adı ve sağlayıcı
 * kartın altında değil, üzerine gelince açılan koyu katmanda görünür. Bu yüzden
 * ad burada `title` olarak da yazılır — dokunmatik cihazda üzerine gelme diye
 * bir şey yok ve ekran okuyucunun okuyacağı tek metin odur.
 *
 * `variant="tile"` kısayol şeridinin küçük kare kartıdır (ana sayfada hero'nun
 * altındaki oyun şeridi): rozet ve ad katmanı taşımaz.
 */
const ParisGameCard = ({ game, onPlay, variant = 'default' }) => {
  const play = () => onPlay?.(game);
  const keyPlay = (event) => { if (event.key === 'Enter') play(); };

  if (variant === 'tile') {
    return (
      <div
        {...hook(HOOKS.GAME_CARD)}
        className="paris-shortcut"
        onClick={play}
        onKeyDown={keyPlay}
        role="button"
        tabIndex={0}
        title={game.name}
      >
        <GameArtwork src={game.img || game.image} alt={game.name} />
      </div>
    );
  }

  return (
    <div
      className="paris-card"
      onClick={play}
      onKeyDown={keyPlay}
      role="button"
      tabIndex={0}
      title={game.name}
    >
      <div className="paris-card-art">
        {game.new && <span className="paris-card-badge is-new">YENİ</span>}
        {!game.new && game.hot && <span className="paris-card-badge">EN İYİ</span>}
        <GameArtwork src={game.img || game.image} alt={game.name} />
        <span className="paris-card-hover">
          <span className="paris-card-play"><Play size={18} fill="currentColor" /></span>
          <span className="paris-card-name">{game.name}</span>
          {game.provider && <span className="paris-card-provider">{game.provider}</span>}
        </span>
      </div>
    </div>
  );
};

export default ParisGameCard;
